// LoadingSpinner.js
import React from 'react';

const Loading = () => {
  return (
    <div className="loading-spinner">
        <div className='funny' >
        <h2>Loading... Please wait.</h2>
        </div>
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
